/**
 * "Back to LevelUp" (Central's suite home) on the first-run wizard steps. The
 * onboarding pop-up (OnboardingModal) has NO exit link: the user stays until
 * done (owner decision 2026-10-09).
 */

/** Central's suite home ("Back to LevelUp") for the wizard's first-run steps. Hidden when Central is not configured. */
export function BackToLevelUpLink({ homeUrl }: { homeUrl: string | null }) {
  if (!homeUrl) return null;
  return (
    <a href={homeUrl} className="text-sm text-gray-600 hover:text-gray-900" data-testid="back-to-levelup">
      Back to LevelUp
    </a>
  );
}
